import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b8ee9c24&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b8ee9c24&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ee9c24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8ee9c24')) {
      api.createRecord('b8ee9c24', component.options)
    } else {
      api.reload('b8ee9c24', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b8ee9c24&scoped=true", function () {
      api.rerender('b8ee9c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/attr/index.vue"
export default component.exports